var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperspaceM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20405 4H12.2661L9.10465 10.8268C8.828 11.4242 8.68966 11.7229 8.73158 11.9511C8.76844 12.1517 8.90001 12.3149 9.10743 12.4172C9.34323 12.5335 9.72239 12.5335 10.4807 12.5335H13.1888C13.3783 12.5335 13.4732 12.5335 13.5321 12.5625C13.5839 12.5881 13.6169 12.6289 13.6261 12.6791C13.6365 12.7361 13.602 12.8108 13.5328 12.9601L12.2485 15.7335H9.26958C6.9946 15.7335 5.8571 15.7335 5.14969 15.3847C4.52744 15.0779 4.13273 14.5884 4.02213 13.9863C3.8964 13.3017 4.31138 12.4056 5.14135 10.6134L8.20405 4ZM15.4985 20H11.4364L14.5979 13.1732C14.8746 12.5758 15.013 12.2771 14.971 12.0489C14.9341 11.8483 14.8026 11.6851 14.5951 11.5828C14.3593 11.4665 13.9802 11.4665 13.2219 11.4665H10.5138C10.3242 11.4665 10.2294 11.4665 10.1705 11.4375C10.1186 11.4119 10.0857 11.3711 10.0765 11.3209C10.066 11.2639 10.1006 11.1892 10.1698 11.0399L11.4542 8.26649H14.433C16.708 8.26649 17.8455 8.26649 18.5529 8.61527C19.1751 8.92207 19.5699 9.41162 19.6805 10.0137C19.8062 10.6983 19.3912 11.5944 18.5613 13.3865L15.4985 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperspaceM);
export default __webpack_public_path__ + "static/media/hyperspace-m.4429992645ead2ba8c421facf0eda597.svg";
export { ForwardRef as ReactComponent };